import styled, { keyframes } from 'styled-components'

import { AlertBarVariant } from '../AlertBar/AlertBar'

const slideDown = keyframes`
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
`

/**
 * Barra fixa no topo, acima de tudo.
 *
 * O `AlertBar` existente é interno de tela (fluxo normal do documento), então não serve para um aviso
 * global — daí este contêiner de posicionamento em volta dele, em vez de um componente novo de visual.
 */
export const FixedTop = styled.div<{ $variant: AlertBarVariant }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  animation: ${slideDown} 200ms ease-out;

  /*
   * Base sólida por baixo do tom translúcido (25%) do AlertBar. Esse tom foi pensado para o fundo
   * escuro do drawer; aqui a barra fica em cima do mapa, e o tom sobre o mapa claro deixava o aviso
   * lavado e o texto quase ilegível (PLA-372). O raio acompanha o do AlertBar.
   */
  background-color: ${({ theme }) => theme.colors.secondaryD1};
  border-radius: 8px;

  /*
   * A barra é puramente informativa: não tem ação, então não deve receber clique.
   *
   * Sem isto ela intercepta os cliques em TODA a largura da sua faixa de 32px, e essa faixa contém o
   * menu hamburguer, o link do Mapbox e o botão "Voltar à versão anterior" — medido, os três ficavam
   * inalcançáveis enquanto o aviso estivesse visível.
   */
  pointer-events: none;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`
